import { Project } from "../../types";

export const allProjects: Project[] = [
  {
    name: "Refine: Minimal Habit Tracker",
    id: 1,
    to: "/strong-habit",
    thumbnail: "/images/iphone-on-wood-mockup.png",
    language: "React Native",
    link: "/strong-habit",
    description:
      "Privacy-first iOS habit and routine tracker with unique streak-freezing and Challenges.",
  },
];
